import React from 'react';
import clsx from 'clsx';
import styles from './TabInput.module.scss';

type Option = {
  id: string | number,
  name: string,
}

function TabInput({
  values, value, onChange, nameAsId = false,
}: {
  values: Option[],
  value: string | number | null | undefined,
  onChange: (v: string | number | undefined | null) => void,
  nameAsId?: boolean,
}) {
  return (
    <div className={styles.container}>
      {(values || []).map((v) => (
        <div
          key={v.id}
          className={clsx(
            styles.item,
            (value === (nameAsId ? v?.name : v?.id)) && styles.itemActive,
          )}
          onClick={() => {
            if ((value === (nameAsId ? v?.name : v?.id))) {
              onChange(undefined)
            } else {
              onChange(nameAsId ? v?.name : v?.id)
            }
          }}
        >
          {v.name}
        </div>
      ))}
    </div>
  )
}

export default TabInput
